import classNames from "classnames";

type BadgeProps = {
  children: React.ReactNode;
  color?: keyof typeof colorMap;
  className?: string;
};
const colorMap = {
  lightgray: "bg-secondary-200 text-black",
  gray: "bg-secondary-600 text-white",
  green: "bg-success-500 text-white",
  pink: "bg-primary-300 text-white",
  red: "bg-primary-500 text-white",
  redOutline: "border border-primary-500 text-primary-500",
  yellow: "bg-warning-400 text-black",
  unique: "bg-[#f1ecd8] text-[#25020b]",
  offer: "bg-[#e8c444] text-[#25020b]",
  soldOut: "bg-[#fcf2ef] text-[#25020b]",
};

export function Badge({ children, color = "gray", className }: BadgeProps) {
  return (
    <div
      className={classNames(
        "text-xs px-1.5 py-0.5 rounded-lg max-w-max",
        className,
        colorMap[color]
      )}
    >
      {children}
    </div>
  );
}
